import axios from "axios";

const backendEac = axios.create({
  baseURL:
    process.env.NODE_ENV !== "production"
      ? "http://localhost:5000"
      : "http://ec2-54-234-136-87.compute-1.amazonaws.com",
});

backendEac.interceptors.request.use(
  (config) => {
    let token = "";
    token = sessionStorage.getItem("token");
    if (!token) token = localStorage.getItem("token");
    if (token) config.headers = { Authorization: `Bearer ${token}` };
    return config;
  },
  (error) => Promise.reject(error)
);

export default backendEac;
